import { useRef, useEffect, useState } from "react";
import GetIcon from "../../../../../utils/Icon";

const Table = ({ setselected_item_data, list_data, po_status }) => {
  const createNewRow = () => ({
    item_code: "",
    item: {},
    required_by: "",
    quantity: "1",
    uom: "",
    rate: "0",
    amount: "0",
  });

  const tableRef = useRef();
  const dropdownRef = useRef();
  const [offset, setOffset] = useState(0);
  const [item_list, setitem_list] = useState([]);
  const [search_input, setsearch_input] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [rows, setRows] = useState([createNewRow()]);
  const [hasMore, setHasMore] = useState(true);


  // const isReadOnly = !!po_status?.result;
  const getItemdata = async (newOffset = 0, searchText = "") => {
    // const res = await list_data({ start: newOffset, search_input: searchText });
    // const products = res?.data?.result?.products || [];
    const products = []
    if (newOffset === 0) {
      setitem_list(products);
    } else {
      setitem_list((prev) => [...prev, ...products]);
    }
    setHasMore(products.length === 20);
  };

  const updateRow = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
    setselected_item_data(updatedRows)
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleAddRow = () => {
    setRows([...rows, createNewRow()]);
    // setselected_item_data([...rows, createNewRow()]);
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows(updatedRows);
    // setselected_item_data(updatedRows);
    setSelectedRows([]);
  };

  useEffect(() => {
    getItemdata(0, "");
  }, []);

  useEffect(() => {
    const dropdown = dropdownRef.current;
    if (!dropdown) return;
    const handleScroll = () => {
      if (dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 && hasMore) {
        const newOffset = offset + 20;
        setOffset(newOffset);
        getItemdata(newOffset, search_input);
      }
    };
    dropdown.addEventListener("scroll", handleScroll);
    return () => dropdown.removeEventListener("scroll", handleScroll);
  }, [offset, hasMore, search_input]);

    const handleDeleteRow = ()=>{}

  useEffect(() => {
    const cols = tableRef.current.querySelectorAll("th");
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);



  return (
    <div className="">
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {["Action", "No.", "Payment Term", "Description", "Due Date", "Invoice Portion", "Payment Amount", " "].map((title, i) => {
              const defaultWidths = {
                "Action": "60px",
                "No.": "90px",
                "Payment Term": "120px",
                "Description": "120px",
                "Due Date": "100px",
                "Invoice Portion": "100px",
                "Payment Amount": "100px",
                " ": "40px",
              };
              return (
                <th
                  key={i}
                  style={{
                    fontSize: '7px',
                    position: "relative",
                    textAlign: "center", 
                    width: defaultWidths[title] || "150px",
                    minWidth: defaultWidths[title] || "150px",
                  }}
                >
                  {title.trim() === "" ? (
                    <GetIcon iconName="PiSlidersHorizontalBold" size={15} color="#fff" />
                  ) : (
                    title
                  )}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td className="p-0" onClick={() => toggleRowSelection(index)} style={{ cursor: 'pointer' }}>
                <p className="m-0" style={{ position: 'relative', top: "2px" }}>
                  {selectedRows.includes(index) ? (
                    <GetIcon iconName="IoIosCheckmarkCircle" color="#ff8d5c" />
                  ) : (
                    <GetIcon iconName="IoIosAddCircle" color="#ff8d5c" />
                  )}
                </p>
              </td>
              <td className="p-0" style={{ position: "relative" }}>
                <input
                  type="text"
                  className="form-control tableinput noborder"
                  style={{ fontSize: '0.8rem' }}
                  onFocus={() => setShowDropdown(index)}
                  onBlur={() => setTimeout(() => setShowDropdown(false), 300)}
                  onChange={(e) => {
                    setsearch_input(e.target.value);
                    setOffset(0);
                    getItemdata(0, e.target.value);
                    updateRow(index, "item_code", e.target.value);
                  }}
                  value={row.item.item_code || row.item_code}
                />
                <div
                  ref={dropdownRef}
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    maxHeight: showDropdown === index ? "200px" : "0",
                    display: showDropdown === index ? '' : 'none',
                    overflowY: "auto",
                    background: "white",
                    border: showDropdown === index ? "1px solid #ccc" : "",
                    zIndex: 10,
                  }}
                >
                  {item_list.map((item, idx) => (
                    <div key={idx}
                      className="text-start"
                      onClick={() => {
                        updateRow(index, "item", item);
                        updateRow(index, "item_code", item.item_code);
                        setsearch_input("");
                        setShowDropdown(false);
                      }}
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                        borderBottom: "1px solid #eee",
                      }}
                    >
                      <p className="m-0">

                        {item.item_code}
                      </p>

                      <div style={{ fontSize: '10px' }}>
                        {item?.item_name}, {item?.item_group}
                      </div>
                    </div>
                  ))}
                  {!hasMore && item_list.length === 0 && (
                    <div style={{ padding: "8px", color: "#888" }}>No results</div>
                  )}
                </div>
              </td>
              <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem' }} readOnly value={row.item.item_name} /></td>
              <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem' }} readOnly value={''} /></td>
              <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem' }} readOnly value={''} /></td>
              <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem' }} value={row.item.buying_price ? row.quantity : ''} onChange={(e) => updateRow(index, "quantity", e.target.value)} /></td>
              <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem' }} value={row.item.stock_uom} /></td>
              <td style={{ textAlign: "center" }}>
                  <GetIcon
                    iconName="MdOutlineDelete"
                    size={18}
                    color="black"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleDeleteRow(index)}
                  />
                </td>
            </tr>
          ))}
        </tbody>

      </table>
      <div className="d-flex" style={{ gap: '4px' }}>
        {selectedRows.length > 0 && (
          <p
            onClick={handleDeleteSelectedRows}
            style={{
              color: "red",
              fontSize: "13px",
              cursor: "pointer",
              width: "fit-content",
              marginBottom: '0px'
            }}
          >
            <GetIcon iconName="FiTrash2" size={14} /> Delete Rows</p>
        )}

        {selectedRows.length == 0 && (<p onClick={handleAddRow} style={{ color: "#270B79", fontSize: "13px", cursor: "pointer", width: 'fit-content' }}>
          <GetIcon iconName="FiPlus" size={14} /> Add Row
        </p>)}

      </div>
    </div>
  );
};

export default Table;
